// Данные из документов и из сообщения — в ответы мастера.
import { plain, relevant, type Field } from "./text";

export type Source = { quote: string; document?: string; note?: string };
export type Prefill = { document: string; answers: Record<string, string>; sources: Record<string, { quote: string }> };
export type Schema = {
  slug: string; title: string; short_title: string; description: string; law: string; intro: string; needs: string;
  attach: string; accepts: string; accepts_title: string; who: string; preview: import("../boot").Paragraph[]; fields: Field[];
};
export type DocState = { schema: Schema; answers: Record<string, string>; sources: Record<string, Source> };

export const remaining = (state: DocState) =>
  state.schema.fields.filter((f) => !(f.key in state.answers) && relevant(f, state.answers)).length;

// Пустые заполняем; то, что человек ввёл сам, не трогаем; списки (дети, имущество) дополняем;
// если другой документ говорит иначе — оставляем первое значение с пометкой «проверьте».
// keys — какие поля заполнены этим документом (их показываем человеку списком), differ — где документы расходятся.
export function absorbPrefill(state: DocState, prefill: Prefill): { added: number; conflicts: number; keys: string[]; differ: string[] } {
  let added = 0;
  let conflicts = 0;
  const keys: string[] = [];
  const differ: string[] = [];
  for (const [key, value] of Object.entries(prefill.answers)) {
    const field = state.schema.fields.find((f) => f.key === key);
    const source: Source = { ...prefill.sources[key], document: prefill.document };
    const current = state.answers[key];
    const known = state.sources[key];
    if (!current) {
      state.answers[key] = value;
      state.sources[key] = source;
      added += 1;
      keys.push(key);
    } else if (!known) {
      continue;
    } else if (field && field.kind === "lines") {
      const have = current.split("\n");
      const extra = value.split("\n").filter((line) => !have.some((other) => plain(other) === plain(line)));
      if (extra.length) {
        state.answers[key] = [...have, ...extra].join("\n");
        state.sources[key] = { ...known, quote: `${known.quote} … ${source.quote}`, document: `${known.document}, ${prefill.document}` };
        added += 1;
        keys.push(key);
      }
    } else if (plain(current) !== plain(value)) {
      state.sources[key] = { ...known, note: `В «${prefill.document}» указано иначе: «${value}» — проверьте.` };
      conflicts += 1;
      differ.push(key);
    }
  }
  return { added, conflicts, keys, differ };
}
